import {
  EmailAuthProvider,
  getAuth,
  reauthenticateWithCredential,
  signInWithEmailAndPassword,
  updateEmail,
  updatePassword,
} from "firebase/auth";

import { axiosInstance } from "../../axios";
import { auth, db } from "../../firebaseConfig";
import {
  getDoc,
  doc,
  collection,
  getDocs,
  setDoc,
  updateDoc,
  addDoc,
  writeBatch,
  deleteDoc,
  query,
  where
} from "firebase/firestore";

export const SignIn = async (body) => {
  try {
    console.log("body");
    console.log(body);

    const auth = getAuth();

    console.log("auth");
    console.log(auth);

    const docRef = await getDoc(doc(db, "AppInfo", "settings"));

    console.log("docRef");
    console.log(docRef);

    await signInWithEmailAndPassword(
      auth,
      body.admin_email,
      body.admin_password
    )
      .then((userCredential) => {
        console.log("userCredential");
        console.log(userCredential);

        const user = userCredential.user;

        console.log("user");
        console.log(user);

        if (docRef.data()?.admin_email == user?.reloadUserInfo?.email) {
          localStorage.setItem("uid", user?.uid);
          return user?.uid;
        } else {
          return "You'r not admin";
        }
      })
      .catch((error) => {
        console.log("error");
        console.log(error);
        const errorCode = error.code;
        const errorMessage = error.message;
        return errorMessage;
      });
  } catch (error) {
    console.log("error");
    console.log(error);
    return error;
  }
};

export const GetAllData = async (collections) => {
  try {
    const docRef = await getDocs(collection(db, collections));
    return docRef;
  } catch (error) {
    return error;
  }
};

export const QueryBusinesses = async (collections, businessName, address) => {
  try {
    const q = query(collection(db, collections), where("businessName", "==", businessName), where("shortAddress", "==", address));

    const docRef = await getDocs(q); 
    return docRef;
  } catch (error) {
    return error;
  }
};

// patch to assign short address from the full address field in Firestore
export const FixShortAddressForBusinesses = async (collections) => {
  try {
    const businesses = await GetAllData(collections)

    // businesses.forEach(async (doc) => {
      
    //   await updateDoc(doc, {
    //     shortAddress: streetAddress
    //   })
    // })
    
    // return businesses;

    const batch = writeBatch(db)
    
    businesses.forEach((item) => {
      const docRef = doc(db, collections, item.id)

      const address = item.data().address ?? ''
      const streetAddress = address.substring(0, address.indexOf(","))

      batch.update(docRef, {
        shortAddress: streetAddress
      })
    })

    await batch.commit()
  } catch (error) {
    console.log(error)
  }
}

export const GetAllDataNestedCollections = async (
  collections,
  id,
  subcollection
) => {
  try {
    const docRef = doc(db, collections, id);
    const subcollectionRef = collection(docRef, subcollection);
    const querySnapshot = await getDocs(subcollectionRef);

    const subcollectionData = [];

    querySnapshot.forEach((doc) => {
      subcollectionData.push(doc.data());
    });

    return subcollectionData;
  } catch (error) {
    return error;
  }
};

export const GetSingleData = async (collection, id) => {
  try {
    const docRef = doc(db, collection, id);
    const docSnap = await getDoc(docRef);
    return docSnap.data();
  } catch (error) {
    return error;
  }
};

export const GetSingleDataNestedCollections = async (
  collection,
  id,
  subcollection,
  subcollectionId
) => {
  try {
    const docRef = doc(db, collection, id, subcollection, subcollectionId);
    const docSnap = await getDoc(docRef);
    return docSnap.data();
  } catch (error) {
    return error;
  }
};

export const getItemsCountNestedCollection = async (
  parentcollection,
  parentId,
  subcollection
) => {
  try {
    const docRef = collection(db, parentcollection, parentId, subcollection);
    const docSnap = await getDocs(docRef);

    const itemsCount = docSnap.size;
    return itemsCount;
  } catch (error) {
    console.error("Error getting menu items count:", error);
    return error;
  }
};

// export const updateAdmin = async (oldEmail, oldPassword, userObject) => {
//   try {
//     console.log("Updating");
//     console.log(oldEmail, oldPassword, userObject);

//     const auth = getAuth();
//     const user = auth.currentUser;

//     await signInWithEmailAndPassword(auth, oldEmail, oldPassword).then(
//       async (userCredential) => {
//         console.log("userCredential");
//         console.log(userCredential);

//         await reauthenticateWithCredential(userCredential);
//         await user.updateEmail(userObject.admin_email);
//         await user.updatePassword(user, userObject.admin_password);

//         const userDocRef = doc(db, "AppInfo", "settings");

//         await updateDoc(userDocRef, userObject);

//         return "Password and user profile updated successfully";
//       }
//     );

//     // const credentials = auth.EmailAuthProvider.credential(
//     //   oldEmail,
//     //   oldPassword
//     // );
//   } catch (error) {
//     console.error("Error updating password:", error);

//     if (error.code === "auth/wrong-password") {
//       throw new Error("The current password is incorrect");
//     } else {
//       throw new Error("Error updating password");
//     }
//   }
// };

export const updateAdmin = async (oldEmail, oldPassword, userObject) => {
  try {
    const auth = getAuth();
    const user = auth.currentUser;

    // Reauthenticate the user
    const credentials = EmailAuthProvider.credential(oldEmail, oldPassword);
    await reauthenticateWithCredential(user, credentials);

    // Update the email
    await updateEmail(user, userObject.admin_email);

    // Update the password (if needed)
    // Uncomment this block if you want to update the password as well
    await updatePassword(user, userObject.admin_password);

    // Update the user profile in Firestore
    const userDocRef = doc(db, "AppInfo", "settings");
    await updateDoc(userDocRef, {
      admin_email: userObject.admin_email,
      admin_password: userObject.admin_password,
    });

    return "Email and user profile updated successfully";
  } catch (error) {
    console.error("Error updating email and user profile:", error);

    if (error.code === "auth/wrong-password") {
      throw new Error("The current password is incorrect");
    } else {
      console.error(error);
      throw new Error("Error updating email and user profile");
    }
  }
};

export const UpdateSingleDoc = async (collection, id, body) => {
  try {
    const docRef = doc(db, collection, id);
    const docSnap = await updateDoc(docRef, body);

    return docSnap;
  } catch (error) {
    return error;
  }
};

export const UpdateSingleDocNEstedCollections = async (
  collection,
  id,
  subcollection,
  subcollectionId,
  body
) => {
  try {
    const docRef = doc(db, collection, id, subcollection, subcollectionId);

    const docSnap = await updateDoc(docRef, body);

    return docSnap.data();
  } catch (error) {
    return error;
  }
};

export const UpdateAllDocsNestedCollections = async (
  collection,
  id,
  subcollection,
  subcollectionId,
  body
) => {
  try {
    const batch = writeBatch(db);

    const docRef = doc(db, collection, id, subcollection, subcollectionId);

    batch.update(docRef, body);
    console.log("Sucesss 1");

    await batch.commit();
    console.log("Sucesss 2");
  } catch (error) {
    console.log(error);
    return error;
  }
};

export const AddSingleDoc = async (collections, body) => {
  try {
    const docRef = await addDoc(collection(db, collections), body);
    console.log("Document written with ID: ", docRef.id);
    await updateDoc(doc(db, collections, docRef.id), {
      id: docRef.id,
    });
    return docRef.id;
  } catch (error) {
    console.log(error, "erorr");
    return error;
  }
};

export const AddSingleDocToBatch = async (batch, collections, body) => {
  try {
    const docRef = doc(db, collections);
    batch.add(docRef, body);
  } catch (error) {
    console.log(error, "erorr");
  }
};

// export const AddSingleDocNestedCollection = async (parentcollection ,restaurantId, subcollection,body) => {
//   try {
//     const docRef = collection(db, parentcollection, restaurantId, subcollection);
//     await addDoc(docRef, body);
//   } catch (error) {
//     return error;
//   }
// };

export const AddSingleDocNestedCollection = async (
  parentcollection,
  restaurantId,
  subcollection,
  body
) => {
  try {
    const parentCollectionRef = collection(db, parentcollection);
    const parentDocumentRef = doc(parentCollectionRef, restaurantId);

    const nestedCollectionRef = collection(parentDocumentRef, subcollection);

    const docRef = await addDoc(nestedCollectionRef, body);

    // Update the document with its own ID
    await updateDoc(docRef, {
      id: docRef.id,
    });

    return docRef.id;
  } catch (error) {
    console.error("Error adding document to nested collection:", error);
    throw error;
  }
};

export const DeleteSingleData = async (collection, id) => {
  try {
    await deleteDoc(doc(db, collection, id));
  } catch (error) {
    return error;
  }
};

export const getDocumentIds = async (collection) => {
  try {
    // Get a reference to the collection
    const collectionRef = collection(db, collection);

    // Get all documents in the collection
    const querySnapshot = await getDocs(collectionRef);

    // Extract document IDs from the query snapshot
    const documentIds = querySnapshot.docs.map((doc) => doc.id);

    return documentIds;
  } catch (error) {
    console.error("Error getting document IDs:", error);
    throw error;
  }
};

export const getDocumentIdsFromNestedCollection = async (
  parentCollectionPath,
  parentDocumentId,
  nestedCollectionPath
) => {
  try {
    // Get a reference to the parent collection and document
    const parentCollectionRef = collection(db, parentCollectionPath);
    const parentDocumentRef = doc(parentCollectionRef, parentDocumentId);

    // Get a reference to the nested collection
    const nestedCollectionRef = collection(
      parentDocumentRef,
      nestedCollectionPath
    );

    // Get all documents in the nested collection
    const querySnapshot = await getDocs(nestedCollectionRef);

    // Extract document IDs from the query snapshot
    const documentIds = querySnapshot.docs.map((doc) => doc.id);

    console.log("documentIds=======");
    console.log(documentIds);

    return documentIds;
  } catch (error) {
    console.error("Error getting document IDs from nested collection:", error);
    throw error;
  }
};

export const createAdmin = async (data) => {
  try {
    const response = await axiosInstance.post(`admin/addAdmin`, data);
    return response;
  } catch (error) {
    return error.response.data.message;
  }
};
